export default __webpack_public_path__ + "static/media/cancel_grey.c9e30d38.svg";